import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import OpenCompositionModal from 'components/OpenCompositionModal'
import { func } from 'prop-types'
import {
    getSelectedComposition,
    getStockCompositionsDataSorted,
    getSelectedCompositionTrackingRoomInfo,
} from 'models/compositions/selectors'
import {
    openComposition as openCompositionAction,
    requestCompositions as requestCompositionsAction,
} from 'models/compositions/actions'
import { compositionType, compositionDataItemsType, trackingRoomInfoType } from 'models/propTypes'

const OpenCompositionModalContainer = ({
    composition,
    closeTryNewRoomModal,
    compositionDataItems,
    openComposition,
    requestCompositions,
    roomInfo,
}) => {
    useEffect(() => {
        const hasNoCompositions = !(compositionDataItems && compositionDataItems.length)
        if (hasNoCompositions) {
            requestCompositions()
        }
    }, [])

    return (
        <OpenCompositionModal
            closeTryNewRoomModal={closeTryNewRoomModal}
            compositionDataItems={compositionDataItems}
            composition={composition}
            openComposition={openComposition}
            roomInfo={roomInfo}
        />
    )
}
OpenCompositionModalContainer.defaultProps = {
    composition: null,
    compositionDataItems: null,
    roomInfo: null,
}

OpenCompositionModalContainer.propTypes = {
    closeTryNewRoomModal: func.isRequired,
    composition: compositionType,
    compositionDataItems: compositionDataItemsType,
    openComposition: func.isRequired,
    requestCompositions: func.isRequired,
    roomInfo: trackingRoomInfoType,
}

const mapStateToProps = (state) => ({
    composition: getSelectedComposition(state),
    compositionDataItems: getStockCompositionsDataSorted(state),
    roomInfo: getSelectedCompositionTrackingRoomInfo(state),
})

const mapDispatchToProps = {
    openComposition: openCompositionAction,
    requestCompositions: requestCompositionsAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(OpenCompositionModalContainer)
